/* global axios */
import ApiClient from './ApiClient';

class MedupFeedAPI extends ApiClient {
  constructor() {
    super('integrations/medup', { accountScoped: true });
  }

  feed() {
    return axios.post(`${this.url}/feed`);
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  departments() {
    return axios.get(`${this.url}/departments`);
  }
}

export default new MedupFeedAPI();
